//export default function useAuth(){ return { user: null }; }

import React, {useState, useEffect, useContext, createContext} from 'react';
import axios from 'axios';
import { API_BASE } from '../config';
console.log('API_BASE', API_BASE);

const AuthContext = createContext();

export function AuthProvider({children}) {
  const auth = useProvideAuth();
  return <AuthContext.Provider value={auth}>{children}</AuthContext.Provider>;
}

//export function useAuth() { return useContext(AuthContext) };
export const useAuth = () => useContext(AuthContext);

export default function useProvideAuth(){
  const [token, setToken] = useState(localStorage.getItem('access_token') || null);
  const [refresh, setRefresh] = useState(localStorage.getItem('refresh_token') || null);
  const [user, setUser] = useState(JSON.parse(localStorage.getItem('user')||'null'));

  useEffect(()=> {
    // attach interceptor to handle 401 and attempt refresh
    const id = axios.interceptors.response.use(resp=>resp, async err=>{
      const original = err.config;
      if (err.response && err.response.status === 401 && refresh && !original._retry){
        original._retry = true;
        try {
          const res = await axios.post(`${API_BASE}/auth.php?action=refresh`, {refresh_token: refresh});
          setToken(res.data.access_token);
          localStorage.setItem('access_token', res.data.access_token);
          return axios(original);
        } catch(e){
          // refresh failed
          logout();
        }
      }
      return Promise.reject(err);
    });
    return () => axios.interceptors.response.eject(id);
  }, [refresh]);

  const login = async (email, password) => {
    console.log('API_BASE 1', API_BASE);
    const res = await axios.post(`${API_BASE}/auth.php?action=login`, {email, password});
    if (res.data && res.data.access_token) {
      setToken(res.data.access_token);
      setRefresh(res.data.refresh_token);
      setUser(res.data.user || null);
      localStorage.setItem('access_token', res.data.access_token);
      localStorage.setItem('refresh_token', res.data.refresh_token);
      localStorage.setItem('user', JSON.stringify(res.data.user || null));
      return true;
    }
    return false;
  };

  const logout = async () => {
    try { await axios.post(`${API_BASE}/auth.php?action=logout`, {}, {headers:{Authorization:`Bearer ${token}`}}); } catch(e){}
    setToken(null); setRefresh(null); setUser(null);
    localStorage.removeItem('access_token'); localStorage.removeItem('refresh_token'); localStorage.removeItem('user');
    console.log('Removed token', localStorage.getItem('access_token'));
  };

  return { token, refresh, user, login, logout, setToken };
}

